export const alpha2CodeMap = {
  AF: { label: 'Afghanistan' },
  AX: { label: 'Aland Islands' },
  AL: { label: 'Albania' },
  DZ: { label: 'Algeria' },
  AS: { label: 'American Samoa' },
  AD: { label: 'Andorra' },
  AO: { label: 'Angola' },
  AI: { label: 'Anguilla' },
  AQ: { label: 'Antarctica' },
  AG: { label: 'Antigua And Barbuda' },
  AR: { label: 'Argentina' },
  AM: { label: 'Armenia' },
  AW: { label: 'Aruba' },
  AU: { label: 'Australia' },
  AT: { label: 'Austria' },
  AZ: { label: 'Azerbaijan' },
  BS: { label: 'Bahamas' },
  BD: { label: 'Bangladesh' },
  BB: { label: 'Barbados' },
  BY: { label: 'Belarus' },
  BE: { label: 'Belgium' },
  BZ: { label: 'Belize' },
  BJ: { label: 'Benin' },
  BH: { label: 'Bahrain' },
  BM: { label: 'Bermuda' },
  BT: { label: 'Bhutan' },
  BO: { label: 'Bolivia' },
  BA: { label: 'Bosnia And Herzegovina' },
  BW: { label: 'Botswana' },
  BV: { label: 'Bouvet Island' },
  BR: { label: 'Brazil' },
  IO: { label: 'British Indian Ocean Territory' },
  BN: { label: 'Brunei Darussalam' },
  BG: { label: 'Bulgaria' },
  BF: { label: 'Burkina Faso' },
  BI: { label: 'Burundi' },
  KH: { label: 'Cambodia' },
  CM: { label: 'Cameroon' },
  CA: { label: 'Canada' },
  CV: { label: 'Cape Verde' },
  KY: { label: 'Cayman Islands' },
  CF: { label: 'Central African Republic' },
  TD: { label: 'Chad' },
  CL: { label: 'Chile' },
  CN: { label: 'China' },
  CX: { label: 'Christmas Island' },
  CC: { label: 'Cocos (Keeling) Islands' },
  CO: { label: 'Colombia' },
  KM: { label: 'Comoros' },
  CG: { label: 'Congo' },
  CD: { label: 'Congo, Democratic Republic' },
  CK: { label: 'Cook Islands' },
  CR: { label: 'Costa Rica' },
  CI: { label: 'Cote DIvoire' },
  HR: { label: 'Croatia' },
  CU: { label: 'Cuba' },
  CY: { label: 'Cyprus' },
  CZ: { label: 'Czech Republic' },
  DK: { label: 'Denmark' },
  DJ: { label: 'Djibouti' },
  DM: { label: 'Dominica' },
  DO: { label: 'Dominican Republic' },
  EC: { label: 'Ecuador' },
  EG: { label: 'Egypt' },
  SV: { label: 'El Salvador' },
  GQ: { label: 'Equatorial Guinea' },
  ER: { label: 'Eritrea' },
  EE: { label: 'Estonia' },
  ET: { label: 'Ethiopia' },
  FK: { label: 'Falkland Islands (Malvinas)' },
  FO: { label: 'Faroe Islands' },
  FJ: { label: 'Fiji' },
  FI: { label: 'Finland' },
  FR: { label: 'France' },
  GF: { label: 'French Guiana' },
  PF: { label: 'French Polynesia' },
  TF: { label: 'French Southern Territories' },
  GA: { label: 'Gabon' },
  GM: { label: 'Gambia' },
  GE: { label: 'Georgia' },
  DE: { label: 'Germany' },
  GH: { label: 'Ghana' },
  GI: { label: 'Gibraltar' },
  GR: { label: 'Greece' },
  GL: { label: 'Greenland' },
  GD: { label: 'Grenada' },
  GP: { label: 'Guadeloupe' },
  GU: { label: 'Guam' },
  GT: { label: 'Guatemala' },
  GG: { label: 'Guernsey' },
  GN: { label: 'Guinea' },
  GW: { label: 'Guinea-Bissau' },
  GY: { label: 'Guyana' },
  HT: { label: 'Haiti' },
  HM: { label: 'Heard Island & Mcdonald Islands' },
  VA: { label: 'Holy See (Vatican City State)' },
  HN: { label: 'Honduras' },
  HK: { label: 'Hong Kong' },
  HU: { label: 'Hungary' },
  IS: { label: 'Iceland' },
  IN: { label: 'India' },
  ID: { label: 'Indonesia' },
  IR: { label: 'Iran' },
  IQ: { label: 'Iraq' },
  IE: { label: 'Ireland' },
  IM: { label: 'Isle Of Man' },
  IL: { label: 'Israel' },
  IT: { label: 'Italy' },
  JM: { label: 'Jamaica' },
  JP: { label: 'Japan' },
  JE: { label: 'Jersey' },
  JO: { label: 'Jordan' },
  KZ: { label: 'Kazakhstan' },
  KE: { label: 'Kenya' },
  KI: { label: 'Kiribati' },
  KR: { label: 'Korea' },
  KW: { label: 'Kuwait' },
  KG: { label: 'Kyrgyzstan' },
  LA: { label: "Lao People's Democratic Republic" },
  LV: { label: 'Latvia' },
  LB: { label: 'Lebanon' },
  LS: { label: 'Lesotho' },
  LR: { label: 'Liberia' },
  LY: { label: 'Libyan Arab Jamahiriya' },
  LI: { label: 'Liechtenstein' },
  LT: { label: 'Lithuania' },
  LU: { label: 'Luxembourg' },
  MO: { label: 'Macao' },
  MK: { label: 'Macedonia' },
  MG: { label: 'Madagascar' },
  MW: { label: 'Malawi' },
  MY: { label: 'Malaysia' },
  MV: { label: 'Maldives' },
  ML: { label: 'Mali' },
  MT: { label: 'Malta' },
  MH: { label: 'Marshall Islands' },
  MQ: { label: 'Martinique' },
  MR: { label: 'Mauritania' },
  MU: { label: 'Mauritius' },
  YT: { label: 'Mayotte' },
  MX: { label: 'Mexico' },
  FM: { label: 'Micronesia' },
  MD: { label: 'Moldova' },
  MC: { label: 'Monaco' },
  MN: { label: 'Mongolia' },
  ME: { label: 'Montenegro' },
  MS: { label: 'Montserrat' },
  MA: { label: 'Morocco' },
  MZ: { label: 'Mozambique' },
  MM: { label: 'Myanmar' },
  NA: { label: 'Namibia' },
  NR: { label: 'Nauru' },
  NP: { label: 'Nepal' },
  NL: { label: 'Netherlands' },
  AN: { label: 'Netherlands Antilles' },
  NC: { label: 'New Caledonia' },
  NZ: { label: 'New Zealand' },
  NI: { label: 'Nicaragua' },
  NE: { label: 'Niger' },
  NG: { label: 'Nigeria' },
  NU: { label: 'Niue' },
  NF: { label: 'Norfolk Island' },
  MP: { label: 'Northern Mariana Islands' },
  NO: { label: 'Norway' },
  OM: { label: 'Oman' },
  PK: { label: 'Pakistan' },
  PW: { label: 'Palau' },
  PA: { label: 'Panama' },
  PG: { label: 'Papua New Guinea' },
  PY: { label: 'Paraguay' },
  PE: { label: 'Peru' },
  PH: { label: 'Philippines' },
  PN: { label: 'Pitcairn' },
  PL: { label: 'Poland' },
  PT: { label: 'Portugal' },
  PR: { label: 'Puerto Rico' },
  QA: { label: 'Qatar' },
  RE: { label: 'Reunion' },
  RO: { label: 'Romania' },
  RU: { label: 'Russian Federation' },
  RW: { label: 'Rwanda' },
  BL: { label: 'Saint Barthelemy' },
  SH: { label: 'Saint Helena' },
  KN: { label: 'Saint Kitts And Nevis' },
  LC: { label: 'Saint Lucia' },
  MF: { label: 'Saint Martin' },
  PM: { label: 'Saint Pierre And Miquelon' },
  VC: { label: 'Saint Vincent And Grenadines' },
  WS: { label: 'Samoa' },
  SM: { label: 'San Marino' },
  ST: { label: 'Sao Tome And Principe' },
  SA: { label: 'Saudi Arabia' },
  SN: { label: 'Senegal' },
  RS: { label: 'Serbia' },
  SC: { label: 'Seychelles' },
  SL: { label: 'Sierra Leone' },
  SG: { label: 'Singapore' },
  SK: { label: 'Slovakia' },
  SI: { label: 'Slovenia' },
  SB: { label: 'Solomon Islands' },
  SO: { label: 'Somalia' },
  ZA: { label: 'South Africa' },
  GS: { label: 'South Georgia And Sandwich Isl.' },
  ES: { label: 'Spain' },
  LK: { label: 'Sri Lanka' },
  SD: { label: 'Sudan' },
  SR: { label: 'Suriname' },
  SJ: { label: 'Svalbard And Jan Mayen' },
  SZ: { label: 'Swaziland' },
  SE: { label: 'Sweden' },
  CH: { label: 'Switzerland' },
  SY: { label: 'Syrian Arab Republic' },
  TW: { label: 'Taiwan' },
  TJ: { label: 'Tajikistan' },
  TZ: { label: 'Tanzania' },
  TH: { label: 'Thailand' },
  TL: { label: 'Timor-Leste' },
  TG: { label: 'Togo' },
  TK: { label: 'Tokelau' },
  TO: { label: 'Tonga' },
  TT: { label: 'Trinidad And Tobago' },
  TN: { label: 'Tunisia' },
  TR: { label: 'Turkey' },
  TM: { label: 'Turkmenistan' },
  TC: { label: 'Turks And Caicos Islands' },
  TV: { label: 'Tuvalu' },
  UG: { label: 'Uganda' },
  UA: { label: 'Ukraine' },
  AE: { label: 'United Arab Emirates' },
  GB: { label: 'United Kingdom' },
  US: { label: 'United States' },
  UM: { label: 'United States Outlying Islands' },
  UY: { label: 'Uruguay' },
  UZ: { label: 'Uzbekistan' },
  VU: { label: 'Vanuatu' },
  VE: { label: 'Venezuela' },
  VN: { label: 'Vietnam' },
  VG: { label: 'Virgin Islands, British' },
  VI: { label: 'Virgin Islands, U.S.' },
  WF: { label: 'Wallis And Futuna' },
  EH: { label: 'Western Sahara' },
  YE: { label: 'Yemen' },
  ZM: { label: 'Zambia' },
  ZW: { label: 'Zimbabwe' },
};

export const alpha2CodeArray = Object.entries(alpha2CodeMap).map(
  ([alpha2Code, { label: name }]) => ({ alpha2Code, name }),
);
